const d3 = require('d3'),
  topojson = require('topojson');

import {gVars} from './00-global-init.js';
import {setYear, fitExtentParams, setOverlayColors, isHOD} from './00-global-functions.js';
import {setAnnotations} from './03-annotations.js';

export function addCityLabels(
  svg_elements, projection, c_year, first_year
  ) {
  var svg = svg_elements[0],
    wrapper_id = svg_elements[3],
    map_class = svg_elements[4],
    all_texas = svg_elements[6];

  var labels = svg.append('g')
    .attr("class","labels");
  var cities_data;

  // Decide how many cities we're showing
  if (all_texas) {
    cities_data = gVars.cities;
  } else {
    cities_data = gVars.cities_coast;
  }

  labels.selectAll('g')
    .data(cities_data)
    .enter()
    .append('g')
    .attr('class', function(d) {
      var label_lower = d.name.replace(/ /g,'').toLowerCase();

      return label_lower + ' city';
    })
    .attr('transform', function(d) {
      var dy = d.y,
        dx = d.x;

      if (window.innerWidth > gVars.mobile_width) {
        if (d.name == 'Gulf of' || d.name == 'Mexico') {
          if (wrapper_id == gVars.map_hod_zoom) {
            dx -= 0.5;
          } else if (map_class == 'two') {
            dx += 0.25;
          } else if (map_class == 'three') {
            dx -= 0.25;
          }
        }

        if (d.name == 'Mexico') {
          if (map_class == 'two') {
            dy += 0.14;
          } else if (map_class == 'three') {
            dy += 0.11;
          } else if (map_class == 'four') {
            dy += 0.095;
          }
        }
      }

      return 'translate(' + projection([dx, dy]) + ')';
    });

  labels.selectAll('g')
    .append('circle')
    .attr('class', 'city-dot')
    .attr('r', 2.5);

  // Create a label for each city
  // And shadow behind it
  // Makes it easier to read in front of some colors
  var classes = ['city-label-shadow', 'city-label'];

  for (var x = 0; x < classes.length; x++) {
    var c_class = classes[x];

    labels.selectAll('g')
      .append('text')
      .attr('class', c_class)
      .attr('text-anchor', (d) => d.textAnchor || 'middle')
      .attr('opacity', function(d) {
        if (c_year == first_year) {
          return 1;
        } else {
          return 0;
        }
      })
      .attr('dx', function(d) {
        if (window.innerWidth > gVars.mobile_width) {
          if (d.name == 'Austin') {
            if (wrapper_id == gVars.map_hod_zoom) {
              return 0;
            } else if (!all_texas && map_class == 'two' || map_class == 'three') {
              return 32;
            } else if (map_class == 'four') {
              return 28;
            } else {
              return d.dx;
            }
          } else if (d.name == 'Corpus Christi') {
            if (wrapper_id == gVars.map_hod_zoom) {
              return 0;
            } else {
              return d.dx;
            }
          } else {
            return d.dx || 0;
          }
        } else {
          return d.dx || 0;
        }
      })
      .attr('dy', function(d) {
        var dy = d.dy,
          dx = d.dx,
          dy_else;

        if (window.innerWidth > gVars.mobile_width) {
          if (!all_texas) {
            if (map_class == 'two') {
              dy_else = -12;
              dy += 6;
            } else {
              dy_else = -6;
            }

            if (d.name == 'Austin') {
              if (wrapper_id == gVars.map_hod_zoom) {
                dy = -10;
              } else if (map_class == 'two' || map_class == 'three') {
                dy = 5;
              } else if (map_class == 'four' || wrapper_id == gVars.map_mini) {
                dy = d.dy;
              } else {
                dy = 15;
              }
            }

            if (d.name == 'Corpus Christi') {
              if (map_class == 'four') {
                dy = -17;
              } else {
                dy = d.dy;
              }
            }
          } else {
            if (d.name == 'Corpus Christi') {
              dy = -9;
            } else {
              dy_else = -8;
            }
          }
        } else {
          if (all_texas && d.name != 'El Paso') {
            dy = -7;
          } else if (d.name == 'Corpus Christi') {
            dy = -15;
          } else {
            dy = d.dy;
          }
        }

        return dy || dy_else;
      })
      .text((d) => d.name);
  // close for
  }
// close export
}

export function loadNueces(
    c_year, c_year_fp_prop, c_topojson_data, svg_elements, geo_path, projection, first_year, all_texas
  ) {
  var url = ASSETS_DATA_DIR + '/nueces';
  var shp_obj = '2010_Census_Counties';

  d3.json(url + '.topojson', function(error, features) {
    if (error) throw error;

    // Data for all of the shapes
    var nueces_topojson = topojson
      .feature(features, features.objects[shp_obj]);

    var counties = svg_elements[1];
    counties.selectAll('path')
      .data(nueces_topojson.features)
      .enter()
      .append('path')
      .attr('d', geo_path)
      .attr("class", "county nueces");

    // Add annotations
    setAnnotations(
      c_year, c_year_fp_prop, c_topojson_data, nueces_topojson, svg_elements, geo_path, first_year, all_texas
    );
  // close d3 json
  });
// close export
}

// Create a shape for each district
export function addShapes(
    c_year, c_year_fp, c_year_fp_prop, c_topojson_data, svg_elements, geo_path, projection, first_year, overlay
  ) {
  var add_count = 0;

  // Set properties for each shape
  var districts = svg_elements[2];
  districts.selectAll('path')
    .data(c_topojson_data.features)
    .enter()
    .each(function() {
      add_count += 1;
    })
    .append('path')
    .attr('d', geo_path)
    .attr("class", function(d) {
      var c_district = d.properties[c_year_fp_prop],
        class_name,
        wrapper_id = svg_elements[3];

      if ( !gVars.hod_maps.includes(wrapper_id) ) {
        if (c_district == gVars.district_num) {
          if (c_year < 2010) {
            class_name = 'dem';
          } else {
            class_name = 'rep';
          }
        } else {
          class_name = 'no-party';
        }

        return 'district district-' + c_district + " " + class_name;
        }
      else {
        // If we're dealing with an hispanic opportunity district
        // we'll highlight
        if ( isHOD(c_year, c_district) ) {
          return 'district district-' + c_district + ' hod';
        } else {
          return 'district district-' + c_district;
        }
      }

    });

  // Bring appropriate district to front
  // After all shapes are on map
  districts.selectAll('path')
    .transition()
    .duration(0)
    .on("end", function(d) {
      add_count -= 1;

      if (add_count == 0) {
        var wrapper_id = svg_elements[3];
        var svg_selector = wrapper_id + ' .map-' + c_year + '-container svg .districts';
        var dist = document.querySelector(
          svg_selector + " .district-" + gVars.district_num
        );

        if (dist) {
          document.querySelector(svg_selector).appendChild(dist);
        }
      }
    // close on end
    });

  var all_texas = svg_elements[6],
    wrapper_id = svg_elements[3];

  // Don't load up if we're dealing with map in key
  if (wrapper_id != gVars.map_key) {
    // Load county outline if we're not showing all of Texas
    loadNueces(
      c_year, c_year_fp_prop, c_topojson_data, svg_elements, geo_path, projection, first_year, all_texas
    );

    // Add city labels if we're displaying first in the series of maps
    // Or display for every map if we're showing all of Texas
    addCityLabels(svg_elements, projection, c_year, first_year);
  }

  // Add circle around the area we're examing for key map
  if (wrapper_id == gVars.map_key) {
    var locator_circle = svg_elements[0].select('.locator-circle');
    locator_circle.selectAll('g')
      .data([gVars.locator_circle])
      .enter()
      .append('circle')
      .attr('r', 28)
      .attr('transform', function(d) {
        return 'translate(' + projection([d.x, d.y]) + ')';
      });
  }
// close export
}

// Add Hispanic overlay (can take other overlays as well)
export function addOverlay(
    c_year, c_year_fp, c_year_fp_prop, svg_elements, geo_path, projection, first_year, url_overlay, shp_obj_overlay
  ) {
  d3.json(url_overlay + '.topojson', function(error, features) {
    var topojson_data_overlay = topojson
      .feature(features, features.objects[shp_obj_overlay]);

    // Get rid of default fill opacity on this district
    // So we can see the overlay
    svg_elements[2].selectAll('.district-27')
      .style('fill-opacity', 0);

    // Set properties for Mexico outline
    var overlay = svg_elements[7];
    overlay.selectAll('path')
      .data(topojson_data_overlay.features)
      .enter()
      .append('path')
      .attr('d', geo_path)
      .attr("class", 'overlay')
      .style('fill', function(d) {
        var perc, overlay;
        if (url_overlay.indexOf('cd27_hispanic') > -1) {
          perc = d.properties.hisp_perc;
          overlay = 'hispanic';
        } else if (url_overlay.indexOf('cd27_vtds') > -1) {
          perc = [d.properties.rep_votes, d.properties.dem_votes, d.properties.rep_perc, d.properties.dem_perc];
          overlay = 'vtds';
        }

        return setOverlayColors(perc, overlay);
      });
  });

  // Add overlay key
  if (c_year == 2012) {
    var overlay_key = d3.select(svg_elements[3] + '-key-wrapper .overlay-key'),
      page;

    if (url_overlay.indexOf('cd27_hispanic') > -1) {
      page = 'hispanic';
    } else if (url_overlay.indexOf('cd27_vtds') > -1) {
      page = 'vtds';
    }

    var percents = setOverlayColors('percents', page),
      key_headers, key_percs;

    if (page == 'hispanic') {
      key_headers = ['Hispanic population'];
      key_percs = ['20&nbsp;&nbsp;', '40&nbsp;&nbsp;', '60&nbsp;&nbsp;', '80%', ''];
    } else if (page == 'vtds') {
      key_headers = ['Vote share: Dem.', 'Vote share: Rep.'];
      key_percs = ['50&nbsp;&nbsp;', '70%', ''];
    }

    for (var k = 0; k < key_headers.length; k++) {
      var key_header_items_container = overlay_key.append('div')
        .attr('class', 'key-header-items-container');
      var key_header = key_header_items_container.append('div')
        .attr('class', 'key-header');
      key_header.append('span')
        .attr('class', 'key-header-middle')
        .html(key_headers[k]);

      var key_container = key_header_items_container.append('div')
        .attr('class', 'key-items-container');

      for (var x = 0; x < percents.length; x++) {
        var c_percent = percents[x],
          keys_data;

        if (page == 'hispanic') {
          keys_data = [c_percent];
        } else if (page == 'vtds') {
          // keys_data = [[5, 10, 0, c_percent], [10, 5, c_percent, 0]];
          keys_data = [[5, 10, 0, c_percent], [10, 5, c_percent, 0]];
        }

        var width = Math.round((100 / percents.length)  * 100 ) / 100;

        var div = key_container.append('span')
          .attr('class', 'key-item')
          .style('width', width + '%');
        div.append('div')
          .attr('class', 'key-item-box')
          .style('background-color', function() {
            return setOverlayColors(keys_data[k], page);
          });
      }

      var key_under = key_header_items_container.append('div')
        .attr('id', 'key-under-' + (k + 1))
        .attr('class', 'key-header key-under');

      for (var y = 0; y < key_percs.length; y++) {
        key_under.append('div')
          .html(key_percs[y]);
      }
    }
  }
}

// Add Mexico right quick
export function addMexico(
    c_year, c_year_fp, c_year_fp_prop, svg_elements, geo_path, projection, first_year
  ) {
  var mex_shp_obj = 'MEX_adm0';
  var mex_url = ASSETS_DATA_DIR + '/mex-outline.topojson';

  d3.json(mex_url, function(error, features) {
    var mex_topojson_data = topojson
      .feature(features, features.objects[mex_shp_obj]);

    // Set properties for Mexico outline
    var mexico = svg_elements[5];
    mexico.selectAll('path')
      .data(mex_topojson_data.features)
      .enter()
      .append('path')
      .attr('d', geo_path)
      .attr("class", 'mexico');
  });
}

// Load topojson data
export function loadData(
    c_year, svg_elements, first_year, overlay, iter_array, zoom_hod, vtds
  ) {
  // Location of topojson file
  var c_year_fp = setYear(c_year)[0];
  var c_year_fp_prop = setYear(c_year)[1];
  var url = ASSETS_DATA_DIR + '/' + c_year_fp;
  var url_split = url.split('/');
  var shp_obj = url_split[url_split.length - 1];

  // Load dat data
  d3.json(url + '.topojson', function(error, features) {
    if (error) throw error;

    // Data for all of the shapes
    var c_topojson_data = topojson
      .feature(features, features.objects[shp_obj]);

    // Set projection and draw map centered around our shape()
    // with our specified width and height
    var wrapper_id = svg_elements[3];
    var map_class = svg_elements[4];
    var all_texas = svg_elements[6];

    var projection = d3.geoConicConformal()
      .parallels([30 + 7 / 60, 31 + 53 / 60])
      .rotate([100 + 20 / 60, 0])
      .fitExtent(
        fitExtentParams(wrapper_id, map_class, all_texas, overlay, zoom_hod), c_topojson_data
      );

    var geo_path = d3.geoPath()
      .projection(projection);

    // Add overlays, voting districts
    if (overlay || vtds) {
      var url_overlay = null,
        shp_obj_overlay = null;

      // Add overlays to maps that have them
      if (overlay) {
        if (overlay == 'hispanic') {
          url_overlay = ASSETS_DATA_DIR + '/cd27_hispanic_' + c_year;
          shp_obj_overlay = 'c_hispanic_' + c_year + '_merge_filter';
        }
      // Add voting districts results if they exist
      } else if (vtds) {
        url_overlay = ASSETS_DATA_DIR + '/cd27_vtds_results_' + c_year;
        shp_obj_overlay = 'b_' + c_year + '_results_filter';
      }

      addOverlay(
        c_year, c_year_fp, c_year_fp_prop, svg_elements, geo_path, projection, first_year, url_overlay, shp_obj_overlay
      );
    }

    // This creates the paths, which are the lines
    // For the map
    // We're gonna add Mexico before adding other shapes
    var mexico = svg_elements[5];
    if (mexico) {
      addMexico(
        c_year, c_year_fp, c_year_fp_prop, svg_elements, geo_path, projection, first_year
      );
    }

    // Add other shapes (districts)
    addShapes(
      c_year, c_year_fp, c_year_fp_prop, c_topojson_data, svg_elements, geo_path, projection, first_year, overlay
    );

  // Close d3 json
  });
// Close export
}



// WEBPACK FOOTER //
// ./02-map-shapes.js